'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _widgetsUtils = require('widgets-utils');

var _style = require('./../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _reviewItem = require('widgets-utils/src/styles/review-item.scss');

var _reviewItem2 = _interopRequireDefault(_reviewItem);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _react2.default.createElement(
    'span',
    null,
    'Verified by'
);

var _ref2 = _react2.default.createElement(_widgetsUtils.DoctifyLogo, null);

var DoctifyWfCarousel = function (_WfAbstractComponent) {
    (0, _inherits3.default)(DoctifyWfCarousel, _WfAbstractComponent);

    function DoctifyWfCarousel() {
        (0, _classCallCheck3.default)(this, DoctifyWfCarousel);
        return (0, _possibleConstructorReturn3.default)(this, _WfAbstractComponent.apply(this, arguments));
    }

    DoctifyWfCarousel.prototype.getSlideContent = function getSlideContent(slide) {
        var _this2 = this;

        return slide.map(function (review) {
            var dateSource = (0, _moment2.default)(review.timestamp_created);
            var date = dateSource.format("DD/MM/YYYY");
            return _react2.default.createElement(
                'div',
                { className: _style2.default['review-addon'] },
                _react2.default.createElement(_widgetsUtils.ReviewItem, {
                    key: review.id,
                    rate: review.aggregate_score,
                    content: review.review.body,
                    date: date,
                    isReviewVerified: review.is_verified,
                    contentStyle: { "height": "70px" },
                    wrapperStyle: { "background-color": _this2.props.reviewItemBackground },
                    showFrame: _this2.props.reviewItemFrame
                })
            );
        });
    };

    DoctifyWfCarousel.prototype.componentDidMount = function componentDidMount() {
        _widgetsUtils.WfAbstractComponent.prototype.componentDidMount.call(this);
        this.onResize();
        if (window) {
            if (window.addEventListener) {
                window.addEventListener("resize", (0, _debounce2.default)(this.onResize, 100));
            } else {
                window.attachEvent("resize", (0, _debounce2.default)(this.onResize, 100));
            }
        }
    };

    DoctifyWfCarousel.prototype.componentWillUnmount = function componentWillUnmount() {
        if (window) {
            if (window.removeEventListener) {
                window.removeEventListener("resize", (0, _debounce2.default)(this.onResize, 100));
            } else {
                window.detachEvent("resize", (0, _debounce2.default)(this.onResize, 100));
            }
        }
    };

    DoctifyWfCarousel.prototype.onResize = function onResize() {
        var width = window.innerWidth;
        var reviewsLimit = 1;

        if (width >= 1050) {
            reviewsLimit = 3;
        } else if (width >= 800) {
            reviewsLimit = 2;
        }

        this.props.resize(reviewsLimit, this.props);
    };

    DoctifyWfCarousel.prototype.render = function render() {
        var _this3 = this;

        var postfixS = this.props.totalReviews > 1 ? 's' : '';
        var bodyStyle = this.props.bodyStyle;
        return _react2.default.createElement(
            'div',
            {
                className: [_style2.default["wf-carousel"], bodyStyle && bodyStyle.backgroundColor && bodyStyle.backgroundColor === "transparent" && _reviewItem2.default["transparent-body"] || '', this.props.wrapperFrame === false && _style2.default['wf-carousel_no-frame']].join(' ')
            },
            _react2.default.createElement(
                'div',
                { className: _style2.default['left-part'] },
                _react2.default.createElement(
                    'a',
                    {
                        href: this.props.href,
                        target: '_blank',
                        rel: 'nofollow noopener'
                    },
                    _react2.default.createElement(_widgetsUtils.VerbalRating, { rate: this.props.averageRating, isRateBold: true }),
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default['start-container'] },
                        _react2.default.createElement(_widgetsUtils.Stars, { rate: this.props.averageRating })
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_widgetsUtils.PatientsReviewsCount, {
                            prefix: 'based on ',
                            reviewsCount: this.props.totalReviews,
                            postfix: " patient review" + postfixS,
                            wrapperClass: _style2.default['patients-reviews-count-addon']
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _style2.default['carousel-logo-row'] },
                        _ref,
                        _ref2
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _style2.default['right-part'] },
                _react2.default.createElement(_widgetsUtils.WidgetCarousel, {
                    slides: this.getSlideContent(this.props.reviews.slice(0, this.props.reviewsLimit)),
                    nextSlide: function nextSlide() {
                        return _this3.props.next(_this3.props);
                    },
                    prevSlide: function prevSlide() {
                        return _this3.props.prev(_this3.props);
                    }
                })
            )
        );
    };

    return DoctifyWfCarousel;
}(_widgetsUtils.WfAbstractComponent);

DoctifyWfCarousel.displayName = 'DoctifyWfCarousel';

DoctifyWfCarousel.defaultProps = {
    reviews: [],
    offset: 0,
    reviewsLimit: 1,
    wrapperFrame: true
};

exports.default = DoctifyWfCarousel;